import * as React from 'react';
import { Route } from 'react-router';

import { Route as CourseraRoute } from '@coursera/react-router';

import loadOnRoute from 'bundles/common/components/loadOnRoute';
import NotFound from 'bundles/phoenix/components/NotFound';
import { CONSUMER_SEARCH_ROUTE } from 'bundles/search-common/constants';
import { inferPageNumberFromParams } from 'bundles/search-common/utils/eventingUtils';
import SearchApp from 'bundles/search-v2/components/SearchV2Application';
import UnifiedUserExperienceHandler from 'bundles/unified-common/providers/UnifiedUserExperienceHandler';

const ConsumerSearchPageRoot = loadOnRoute(() => import('bundles/search-common/pages/SearchPageRoot'));

const SearchAppWithUserExperienceHandler = (props: React.ComponentProps<typeof SearchApp>) => (
  <UnifiedUserExperienceHandler>
    <SearchApp {...props} />
  </UnifiedUserExperienceHandler>
);

export default (
  <CourseraRoute
    path="/"
    component={SearchAppWithUserExperienceHandler}
    handle={{
      tracking: {
        data: (_, location) => {
          const currentPage = inferPageNumberFromParams(location?.query?.page);

          return {
            page: {
              segment: 'consumer',
              type: 'search_result_page',
              pagination: {
                pageNumber: currentPage ? Number(currentPage) : 1,
              },
            },
          };
        },
      },
    }}
  >
    <Route path={CONSUMER_SEARCH_ROUTE} getComponent={ConsumerSearchPageRoot} />
    <Route path="search-v2" getComponent={ConsumerSearchPageRoot} />
    <Route path="*" component={NotFound} />
  </CourseraRoute>
);
